import React from 'react'
import AntdSelect from 'antd/lib/select'
import debounce from 'lodash/debounce'

import './select.less'

import { mergeClassName } from '../utils'

export const closest = (el, fn) => {
  while (el) {
    if (fn(el)) {
      return el
    }

    el = el.parentNode
  }

  return null
}

class DmpSelect extends React.Component {
  handleCloseDropdown = debounce((e) => {
    if (closest(e.target, el => el.classList && (el.classList.contains('ant-select-dropdown') || el.classList.contains('ant-select')))) return
    document.body.dispatchEvent(new Event('touchstart', { bubbles: true }))
  }, 200, { leading: true })

  render() {
    const { className, dropdownClassName, dark, ...otherProps } = this.props
    const { size } = this.props

    let sizeClass = ''
    switch (size) {
      case 'large':
        sizeClass = 'ant-select-lg'
        break
      case 'small':
        sizeClass = 'ant-select-sm'
        break
      default:
    }

    let newClassName = className
    const newDropdownClass = [dropdownClassName, sizeClass]

    if (dark) {
      newClassName = [className, 'dark-theme']
      newDropdownClass.push('dark-theme')
    }

    return (
      <React.Fragment>
        <AntdSelect
          ref={(e) => { this.selector = e }}
          onDropdownVisibleChange={this.handleVisibleChange}
          {...otherProps}
          className={mergeClassName(newClassName)}
          dropdownClassName={mergeClassName(newDropdownClass, 'dmp-antd-select')}
        />
      </React.Fragment>
    )
  }

  bindScrollHandler() {
    document.addEventListener('wheel', this.handleCloseDropdown)
    document.addEventListener('scroll', this.handleCloseDropdown)
  }

  unbindScrollHandler() {
    document.removeEventListener('wheel', this.handleCloseDropdown)
    document.removeEventListener('scroll', this.handleCloseDropdown)
  }

  handleVisibleChange = (visible) => {
    const { closeOnScroll, onDropdownVisibleChange } = this.props
    if (visible && closeOnScroll) {
      this.bindScrollHandler()
    } else {
      this.unbindScrollHandler()
    }

    if (typeof onDropdownVisibleChange === 'function') {
      onDropdownVisibleChange(visible)
    }
  }
}

const { Option, OptGroup } = AntdSelect
DmpSelect.Option = Option
DmpSelect.OptGroup = OptGroup

export default DmpSelect
